import { APIClient } from "api/apiCore";
import LightBox from "components/LightBox";
import LightBox2 from "components/LightBox2";
import Loader from "components/Loader";
import { Utils } from "helpers/utils";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as urls from "../../../api/urls";


interface WorkplaceCollectionProps {
  postIdParent: string;
  // index: number;
  selImageId: string;
  onToggle(): void;
}
const WorkplaceCollection = ({ postIdParent,/* index,*/ selImageId, onToggle }: WorkplaceCollectionProps) => {
  const { parmPostIdParent, parmImageId } = useParams();
  // console.log('use param:', { parmPostIdParent, parmIndex });
  const postIdParentUsed = parmPostIdParent ? parmPostIdParent : postIdParent;
  const selImageIdUsed = parmImageId ? parmImageId : selImageId;
  // const indexUsed = parmIndexNumber < 0 ? index : parmIndexNumber;
  // console.log('parm:', { postIdParentUsed, indexUsed });
  // const images = [
  //   {
  //     fileId: "1",
  //     downloadLink: "https://www.skyweaver.net/images/media/wallpapers/wallpaper1.jpg",
  //     title: "title1", description: "description1"
  //   },
  //   {
  //     fileId: "2",
  //     downloadLink: "https://e0.pxfuel.com/wallpapers/473/196/desktop-wallpaper-beautiful-sky-digital-art.jpg",
  //     title: "title2", description: "description2"
  //   },
  //   {
  //     fileId: "3",
  //     downloadLink: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTbbPcjGkP5FvdMQmCYPFA3IWDhS_8QrgI7I2mlQ89_KExvhYz_7A4tfZ7Bec2ArI2eYWU&usqp=CAU",
  //     title: "title3", description: "description3"
  //   },
  // ];
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [images, setImages] = useState<any[]>([]);
  const [indexUsed, setIndexUsed] = useState<number>(0);
  useEffect(() => {
    try {
      const api = new APIClient();
      setIsLoading(true);
      api.fnPostForm(urls.WP_LOAD_POST_IMAGE_FOR_GALLARY, { postIdParent: postIdParentUsed })
        .then(rs => {
          // console.log({ selImageIdUsed, rs });
          const idx = rs.findIndex((x: any) => x.imageId === selImageIdUsed);
          // console.log('img idx = ' + idx);
          setIndexUsed(idx >= 0 ? idx : 0);
          const rs2 = rs.map((x: any, index: number) => ({
            ...x,
            fileId: x.imageId,
            downloadLink: x.url,
            title: `(${index + 1}/${rs.length}) ` + x.postByName + ' ' + Utils.GetShortDateTimeToShowInChat(x.createDate, false),
            description: x.fileName,
          }));
          // console.log('rs2:', rs2);
          setImages(rs2);
          setIsLoading(false);
        })
        .catch(er => {
          Utils.HandleException(er, true);
          setIsLoading(false);
        })


    } catch (e) {
      setIsLoading(false);
      Utils.HandleException(e, true);
    }

  }, [postIdParentUsed]);

  const onToggle2 = () => {
    if (Utils.IsDesktop()) {
      window.close();
    }
    onToggle();
  }

  return (
    <>
      {images.length > 0 && (
        <LightBox2
          isOpen={true}
          onClose={onToggle2}
          images={images}
          defaultIdx={indexUsed}
          allowRotate={false}
          showInfo={true}
        />
      )}
    </>
  )
}

export default WorkplaceCollection;